<template>
  <div class="page">
    <!-- 预约列表 -->
    <oabCard v-if="listData.length" :data="listData" @clickBtn="clickBtn"></oabCard>
    <van-divider v-if="!listData.length && !loading" dashed :style="style">暂无数据</van-divider>
    <load :isShow="loading" />
    <!-- 取消弹窗 -->
    <van-dialog
      v-model:show="isShowDialog"
      title=""
      :before-close="beforeCloseDialog"
      show-cancel-button
      :confirm-button-text="dialogConfig.confirmButtonText"
      confirm-button-color="#3088c5"
    >
      <div class="dialogContent">
        <h3 class="title" v-if="dialogConfig.title">
          {{ dialogConfig.title }}
        </h3>
        <div v-html="dialogConfig.content"></div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import oabCard from '@/components/oab/listCard.vue'
import load from '@/components/oab/fullLoad.vue'
import { getOrderList, cancleOab } from '@/api/oab'
import { reorganizeListData, calculateTimeout } from '@/util/oab'
import { btnCallBack } from '@/util/order/handle'
import { showToast } from '@/util/couponCollection'

export default {
  components: {
    oabCard,
    load
  },
  setup() {
    let router = useRouter()
    const state = reactive({
      listData: [],
      loading: false,
      isShowDialog: false,
      dialogConfig: {
        // title: '确认取消',
        content: '是否确认取消订单？',
        confirmButtonText: '确认取消',
        cancelButtonText: '暂不取消'
      },
      style: { color: '#999', borderColor: '#aaa', padding: '0 56px' }
    })
    // 获取预约列表数据
    const getListData = async isShowLoad => {
      try {
        isShowLoad && (state.loading = true)
        let data = await getOrderList()
        let listData = reorganizeListData(data)
        state.listData = listData
        state.loading = false
      } catch (e) {
        showToast(e.message, '获取预约列表数据失败')
        state.listData = []
        state.loading = false
      }
    }
    onMounted(async () => {
      getListData(true)
    })
    // 点击按钮
    const clickBtn = v => {
      let { id, _data } = v
      console.log('clickBtn-->', id, _data)
      if (id === 'cancel') {
        let res = calculateTimeout(_data.cancelTime)
        if (!res) {
          getListData()
        } else {
          const param = { reservationId: _data.id }
          state.dialogConfig = Object.assign(state.dialogConfig, { subParam: { v, param }, cb: cancleOab })
          state.isShowDialog = true
        }
      }
      if (id === 'view') {
        router.push({
          path: v.path,
          query: { from: 'oabList', oabId: _data.id }
        })
      }
    }
    //关闭弹窗
    const beforeCloseDialog = async action => {
      if (action === 'confirm') {
        try {
          const {
            subParam: { v, param },
            cb
          } = state.dialogConfig
          // console.log(state.dialogConfig.subParam,param)
          cb && (await cb(param))
          v.fn && (await btnCallBack(v, param))
          nextTick(async () => {
            await getListData()
          })
          return true
        } catch (e) {
          showToast(e.message, '操作失败')
        }
      }
      if (action === 'cancel') {
        state.dialogConfig.subParam = {}
        return true
      }
    }
    return {
      ...toRefs(state),
      clickBtn,
      beforeCloseDialog
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  padding-top: 10px;
  padding-bottom: calc(16px + constant(safe-area-inset-bottom));
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  :deep(.noBorder) {
    border: none !important;
  }
  :deep(.radius) {
    border-radius: 14px !important;
  }
  :deep(.van-popup.van-dialog button) {
    background: #fff;
    color: #666;
  }
  :deep(.dialogContent) {
    padding: 38px 10px;
    color: #333;
    font-size: 16px;
    font-weight: 400;
  }
}
</style>
